import $ from 'jquery';

class ContentBlock {
    constructor(target, settings) {
        
    }

    init() {
        this.calculateContainerSizes();
    }

    setEvents() {
        $(window).resize(() => {
            this.calculateContainerSizes();
        });
    }

    calculateContainerSizes() {
        let videoContainer = $('.video-container');
        videoContainer.each((e) => {
            this.setContainerHeight(e);
        });
        let imageContainer = $('.image-container');
        imageContainer.each((e) => {
            this.setContainerHeight(e);
        });
    }

    setContainerHeight(element) {
        let mainContainer = $(element).parents('section .container');
        if ($(window).width() > 992) {
            let videoElement = $(element).find('.content-block-media-wrapper');

            if (videoElement !== undefined || mainContainer !== undefined || element !== undefined) {
                $(mainContainer).css('min-height', $(videoElement).outerHeight() + 20);
            }
        } else if (mainContainer !== undefined) {
                $(mainContainer).css('min-height', '');
        }
    }
}

export default ContentBlock;

$(() => {
	const content = new ContentBlock();
	content.init();
});